<mat-form-field class="inline-edit-textfield">
  <mat-label>{{ labelText | translate }}</mat-label>
  <input
    #input
    matInput
    class="form-control"
    [(ngModel)]="editingText"
    [required]="required"
    (focus)="openEditMode()"
    (focusout)="focusOut()"
    (keyup.enter)="emitUpdate($event)" />
  @if (!buttonInEditMode) {
    <mat-icon matSuffix class="opacity-50">edit</mat-icon>
  }
  @if (buttonInEditMode) {
    <mat-icon matSuffix (click)="emitUpdate($event)" class="edit-mode-button">save</mat-icon>
  }
  @if (validationError) {
    <mat-hint class="invalid">{{ validationError | translate }}</mat-hint>
  }
  @if (!validationError && buttonInEditMode && !disableHint) {
    <mat-hint class="regular-hint">{{ "generic.pressEnterToSave" | translate }}</mat-hint>
  }
</mat-form-field>
